import { Box } from '@mui/material';
import { AgingBucket } from 'src/types';
import { useLocales } from 'src/locales';
import { AGING_BUCKET_CONFIG } from './aging-bucket-config';

type Props = {
  bucket: AgingBucket;
};

export default function AgingBucketBadge({ bucket }: Props) {
  const { t } = useLocales('operativaDashboard');
  const { badge, labelKey } = AGING_BUCKET_CONFIG[bucket];

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        typography: 'caption',
        px: 1.25,
        py: 0.25,
        borderRadius: '99px',
        fontWeight: 'fontWeightMedium',
        whiteSpace: 'nowrap',
        backgroundColor: badge.light.bg,
        color: badge.light.text,
        '[data-color-scheme="dark"] &': {
          backgroundColor: badge.dark.bg,
          color: badge.dark.text,
        },
      }}
    >
      {t(labelKey)}
    </Box>
  );
}
